import styled, { keyframes } from 'styled-components';
import { Link } from 'react-router-dom';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const ProjectContainer = styled.div`
  min-height: 100vh;
  background: #fff;
  padding: 4rem 2rem;
  animation: ${fadeIn} 0.6s ease;
`;

export const ProjectHeader = styled.div`
  max-width: 1400px;
  margin: 0 auto 4rem;
  text-align: center;
`;

export const ProjectTitle = styled.h1`
  font-size: 3rem;
  font-weight: 500;
  margin-bottom: 1rem;
  color: #000;
`;

export const ProjectCategory = styled.div`
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 0.5rem;
`;

export const ProjectYear = styled.div`
  font-size: 1rem;
  color: #999;
`;

export const MainImage = styled.div`
  // width: 100%;
  height: 80vh;
  margin-bottom: 4rem;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

  img {
    // width: 100%;
    height: 100%;
    object-fit: contain;
    transition: transform 0.6s ease;
    display: block;
    margin: 0 auto;
  }

  &:hover img {
    transform: scale(1.05);
  }
`;

export const ProjectContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 4rem;
  padding: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const ProjectInfo = styled.div`
  position: sticky;
  top: 2rem;
  height: fit-content;
  background: #f8f8f8;
  padding: 2rem;
  border-radius: 8px;
`;

export const InfoSection = styled.div`
  margin-bottom: 2rem;

  h3 {
    font-size: 1.2rem;
    font-weight: 500;
    margin-bottom: 0.8rem;
    color: #000;
  }

  p {
    font-size: 1rem;
    line-height: 1.6;
    color: #666;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      font-size: 1rem;
      color: #666;
      padding: 0.5rem 0;
      border-bottom: 1px solid #eee;

      &:last-child {
        border-bottom: none;
      }
    }
  }
`;

export const ProjectDescription = styled.div`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #333;

  p {
    margin-bottom: 2rem;
    
    &:first-of-type {
      font-size: 1.2rem;
      color: #000;
      font-weight: 300;
    }
  }
`;

export const Navigation = styled.div`
  max-width: 1200px;
  margin: 4rem auto 0;
  padding: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #eee;
`;

export const NavButton = styled(Link)`
  display: flex;
  align-items: center;
  gap: 1rem;
  text-decoration: none;
  color: #000;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  padding: 1rem;
  border-radius: 8px;

  &:hover {
    background: #f8f8f8;
    transform: translateX(${props => props.next ? '10px' : '-10px'});
  }

  span {
    font-size: 1.5rem;
  }
`;

export const BackToGallery = styled(Link)`
  display: inline-block;
  padding: 1rem 2rem;
  background: #000;
  color: #fff;
  text-decoration: none;
  border-radius: 30px;
  transition: all 0.3s ease;
  margin-top: 2rem;
  font-size: 1rem;
  text-align: center;

  &:hover {
    background: #333;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
`; 